import React from 'react'
import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import reducer, { openAdd, openAppEdit } from './store'
import { REDUCER_NAME } from './constants'

const constants = { REDUCER_NAME }

const ApplicationAdd = Loadable(() => import('./Components/ApplicationAdd'))

// omit name value because it will be function
const ApplicationAddModal = () => <ApplicationAdd />

// TODO: take care with openAdd identity
export const createApplicationAddNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'application_add',
  text: translateFn('mnu_application_add'),
  identity: openAdd,
  permission: 'ADD_APPLICATION',
  component: ApplicationAddModal,
}))

export const ApplicationEdit = Loadable(() => import('./Components/ApplicationEdit'))

export { reducer, constants, openAppEdit }
